import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-timestamp-menu',
    templateUrl: './timestamp-menu.component.html',
    styleUrls: ['./timestamp-menu.component.css'],
})
export class TimestampMenuComponent {
    /**
     * The name of the timestamp webpagemenu to load into generic webpagemnu component.
     */
    public webpageName = '';

    constructor(private state: StateService) {
        this.webpageName = this.state.getCurrentName();
    }
}
